module.exports = __webpack_public_path__ + "static/media/kkk.a05f7cc1.JPG";